import { Button } from 'antd'
import PropTypes from 'prop-types'
import { useHref, useLinkClickHandler } from 'react-router-dom'

/**
 * A link that looks like an antd Button, rendered as a single element.
 *
 * `<Link><Button /></Link>` puts an anchor around a button, so every action is
 * two tab stops and the inner one has no accessible name. Giving Button an
 * `href` makes it render the anchor itself, and react-router's own link hooks
 * keep client-side navigation, modifier-clicks and middle-click working.
 */
export default function ButtonLink({
  to,
  state = undefined,
  target = undefined,
  replace = false,
  ...rest
}) {
  const href = useHref(to)
  const handleClick = useLinkClickHandler(to, { state, target, replace })

  return (
    <Button
      {...rest}
      href={href}
      target={target}
      onClick={event => {
        if (!event.defaultPrevented) handleClick(event)
      }}
    />
  )
}

ButtonLink.propTypes = {
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  state: PropTypes.object,
  target: PropTypes.string,
  replace: PropTypes.bool,
}
